import { LOG_CSS_COLORS, LOG_CSS_ERROR_COLORS } from '../constants'

export const logInfo = (message: string, value?: any) => {
  console.log('%c%s', LOG_CSS_COLORS, message, value)
}

export const logError = (message: string, value?: any) => {
  console.error('%c%s', LOG_CSS_ERROR_COLORS, message, value)
}
